module.exports = __webpack_public_path__ + "static/media/Galdisa_Ficha_pepita_blanca_cruda.3866ff2a.pdf";